export const en = {
    cancel: 'Cancel',
    create: 'Create',
    'new-creative': 'New creative'
};
